export function createStripeBtn(response) {
    let stripeBtn = document.createElement("script");
    stripeBtn.setAttribute("src", "https://checkout.stripe.com/checkout.js");
    stripeBtn.setAttribute("class", "stripe-button");
    stripeBtn.setAttribute("data-key", response.data.data_key);
    stripeBtn.setAttribute("data-amount", response.data.data_amount);
    stripeBtn.setAttribute("data-currency", response.data.data_currency);
    stripeBtn.setAttribute("data-description", "Spring course checkout");
    stripeBtn.setAttribute("data-locale", "auto");
    stripeBtn.setAttribute("data-zip-code", "false");
    return stripeBtn;
}